import React, { useState } from 'react';

import LoadingComponent from './loading/loading.component';

const WidgetComponent = ({ botId }: { botId: string }) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  const handleIframeLoad = () => {
    setIsIframeLoaded(true);
  };

  return (
    <div style={{ position: 'relative', width: '360px', height: '640px' }}>
      {!isIframeLoaded && <LoadingComponent />}

      <iframe
        src={`https://widget.louisebot.com/bots/${botId}?pageUrl=https%3A%2F%2Flouisebot.com&open=true&hideMinimizeButton=true&hideCloseButton=true&mute=true`}
        allow="microphone"
        title="louisebot.com"
        name="louisebot.com"
        allowFullScreen
        onLoad={handleIframeLoad}
        style={{
          position: 'relative',
          border: '0px',
          background: 'transparent',
          pointerEvents: 'auto',
          overflow: 'hidden',
          zIndex: 10,
          width: '360px',
          height: '640px',
          transition: 'width 0.3s, height 0.3s',
          boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0.48px 2.41px -0.38px, rgba(0, 0, 0, 0.17) 0px 4px 20px -0.75px',
          borderRadius: '25px',
          visibility: isIframeLoaded ? 'visible' : 'hidden',
          maxWidth: '100vw',
          maxHeight: '100vh',
          transform: 'scale(1)',
          transformOrigin: 'top right',
        }}
      />
    </div>
  );
};

export default WidgetComponent;
